export default "__VITE_ASSET__C0SuqCno__"